import React from 'react'
import Destinos from './Destinos';
import Filter from '../../../Auxiliar/Filter';
import Compliances from '../Compliance/Compliances';

const SelecionarDestinos = () => {
  const [search, setSearch] = React.useState(false)
  const [dateOf, setDateOf] = React.useState('')
  const [dateFor, setDateFor] = React.useState('')
  const [options, setOptions] = React.useState({
    destinos: { value: true, label: 'Destinos', checked: true },
    compliances: { value: false, label: 'Compliances', checked: false },
  })

  return (
    <div className="card">
      <div className="card-body" id="card">
        <h4 className="mt-0 header-title" style={{ fontSize: '1.5rem', color: 'black' }}>Destinos</h4>
        <Filter setDateOf={setDateOf} setDateFor={setDateFor} options={options} setOptions={setOptions} setSearch={setSearch} />
        <div>
          <p style={{ fontSize: '1rem', color: 'black' }}>Aqui são listados os destinos do sistema</p>
        </div>
        <div className="row">
          {options.destinos.value &&
            <Destinos dateOf={dateOf} dateFor={dateFor} search={search} setSearch={setSearch} />}
          {options.compliances.value &&
            <Compliances dateOf={dateOf} dateFor={dateFor} search={search} setSearch={setSearch} owner={'destinos'} searchFor='destiny_id' />}
        </div>
      </div>
    </div>
  )
}

export default SelecionarDestinos